export default __webpack_public_path__ + "static/media/uaepass-round.3b792c39.svg";